/* =========================================
   SQUALO Quick Add
   - Desktop: hover bar shows sizes (CSS-only), click adds to cart
   - Mobile: first tap on card image opens a bottom-sheet of sizes,
             tap on a size adds to cart
   - On success: re-renders cart-drawer (or cart-notification) and opens it
   ========================================= */
(function () {
  'use strict';

  const isCoarsePointer = () =>
    window.matchMedia('(hover: none), (max-width: 749px)').matches;

  const cartTarget = () =>
    document.querySelector('cart-drawer') || document.querySelector('cart-notification');

  const ensureBackdrop = () => {
    let bd = document.querySelector('.squalo-quick-sizes__backdrop');
    if (!bd) {
      bd = document.createElement('div');
      bd.className = 'squalo-quick-sizes__backdrop';
      document.body.appendChild(bd);
      bd.addEventListener('click', closeSheet);
    }
    return bd;
  };

  const ensureSheetChrome = (sheetEl) => {
    if (sheetEl.dataset.sheetChrome === 'true') return;
    const title = document.createElement('span');
    title.className = 'squalo-quick-sizes__sheet-title';
    title.textContent =
      (sheetEl.dataset.productTitle || 'Talle') + ' — Elegí tu talle';
    sheetEl.insertBefore(title, sheetEl.firstChild);

    const closeBtn = document.createElement('button');
    closeBtn.type = 'button';
    closeBtn.className = 'squalo-quick-sizes__sheet-close';
    closeBtn.setAttribute('aria-label', 'Cerrar');
    closeBtn.innerHTML = '&times;';
    closeBtn.addEventListener('click', closeSheet);
    sheetEl.appendChild(closeBtn);

    sheetEl.dataset.sheetChrome = 'true';
  };

  let openSheetEl = null;

  // .card__inner tiene transform (translateZ) que crea un containing block
  // nuevo para position:fixed (CSS spec). Por eso una sheet con position:fixed
  // dentro del card queda atrapada al card en vez de ocupar el viewport.
  // Solución: mover la sheet al <body> al abrir, restaurarla al cerrar.
  const openSheet = (sheetEl) => {
    if (openSheetEl && openSheetEl !== sheetEl) closeSheet();
    ensureSheetChrome(sheetEl);

    if (!sheetEl._squaloHome) {
      sheetEl._squaloHome = {
        parent: sheetEl.parentNode,
        next: sheetEl.nextSibling,
      };
    }
    document.body.appendChild(sheetEl);

    const bd = ensureBackdrop();
    bd.classList.add('is-open');
    sheetEl.classList.add('is-sheet-open');
    document.body.classList.add('overflow-hidden');
    openSheetEl = sheetEl;
  };

  function closeSheet() {
    if (!openSheetEl) return;
    openSheetEl.classList.remove('is-sheet-open');

    const home = openSheetEl._squaloHome;
    if (home && home.parent) {
      if (home.next && home.next.parentNode === home.parent) {
        home.parent.insertBefore(openSheetEl, home.next);
      } else {
        home.parent.appendChild(openSheetEl);
      }
    }

    openSheetEl = null;
    const bd = document.querySelector('.squalo-quick-sizes__backdrop');
    if (bd) bd.classList.remove('is-open');
    document.body.classList.remove('overflow-hidden');
  }

  document.addEventListener('keyup', (e) => {
    if (e.key === 'Escape') closeSheet();
  });

  /* ---- Mobile: tap on card image opens the sheet (instead of navigating) ---- */
  document.addEventListener(
    'click',
    (e) => {
      if (!isCoarsePointer()) return;
      const gallery = e.target.closest('.squalo-swipe-gallery');
      if (!gallery) return;
      const wrapper = gallery.closest('.squalo-card-wrapper');
      if (!wrapper) return;
      const sheet = wrapper.querySelector('.squalo-quick-sizes');
      if (!sheet) return;

      e.preventDefault();
      e.stopPropagation();
      openSheet(sheet);
    },
    true
  );

  /* ---- Click on a size button → AJAX add to cart ---- */
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('.squalo-quick-sizes__btn');
    if (!btn) return;

    e.preventDefault();
    e.stopPropagation();

    if (btn.classList.contains('is-soldout') || btn.classList.contains('is-loading')) return;
    if (btn.dataset.variantAvailable === 'false') return;

    const variantId = btn.dataset.variantId;
    if (!variantId) return;

    btn.classList.add('is-loading');

    const cart = cartTarget();
    const addUrl =
      (window.routes && window.routes.cart_add_url) || '/cart/add.js';

    const formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', '1');

    if (cart && typeof cart.getSectionsToRender === 'function') {
      const sectionIds = cart.getSectionsToRender().map((s) => s.id).join(',');
      formData.append('sections', sectionIds);
      formData.append('sections_url', window.location.pathname);
      // OJO: NO pasar el botón como activeElement. La barra usa :focus-within
      // en .card__media para mostrarse; si el drawer le devuelve el focus al
      // botón al cerrarse, la barra queda visible "pegada". Usamos el link
      // del título como destino — semántico y fuera del .card__media.
      const wrapperEl = btn.closest('.squalo-card-wrapper');
      const titleLink = wrapperEl && wrapperEl.querySelector('.card__heading a');
      cart.setActiveElement(titleLink || document.activeElement);
    }

    try {
      const res = await fetch(addUrl, {
        method: 'POST',
        headers: {
          Accept: 'application/javascript',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: formData,
      });
      const data = await res.json();

      if (data.status) {
        btn.classList.remove('is-loading');
        if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS) {
          window.publish(window.PUB_SUB_EVENTS.cartError, {
            source: 'squalo-quick-add',
            productVariantId: variantId,
            errors: data.errors || data.description,
            message: data.message,
          });
        }
        return;
      }

      btn.classList.remove('is-loading');
      btn.classList.add('is-added');
      setTimeout(() => btn.classList.remove('is-added'), 900);

      // Sacarle el focus al botón ya — si no, :focus-within sobre .card__media
      // deja la barra de talles "pegada" visible incluso después de cerrar el drawer.
      btn.blur();

      if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS) {
        window.publish(window.PUB_SUB_EVENTS.cartUpdate, {
          source: 'squalo-quick-add',
          productVariantId: variantId,
          cartData: data,
        });
      }

      closeSheet();

      if (cart && typeof cart.renderContents === 'function') {
        // Mirror Dawn's product-form.js: si el <cart-drawer> tiene .is-empty
        // (carrito vacío al cargar la página), hay que sacárselo o el CSS
        // oculta el área de items aunque renderContents reemplace el HTML.
        if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
        cart.renderContents(data);
      }
    } catch (err) {
      btn.classList.remove('is-loading');
      console.error('[squalo-quick-add] add failed', err);
    }
  });
})();
